export default "__VITE_ASSET__BKzmAbp2__"